

import { useState } from 'react';
import { Grid, TextField } from '@mui/material'
import { BotonesAndCargando } from '../../components/botones'
import { useImagenStore } from '../../../stores';
import { AvatarScreen } from '../../ui';
import { slideshowCreateImagen } from '../../../services';
import { useQueryClient } from '@tanstack/react-query';



export const FormCreatUpdateSlide = () => {

    const queryClient = useQueryClient();
    const [ formTitulo, setFormTitulo ] = useState('');
    const { imagen, valorImagen } = useImagenStore();
    const [cargando, setCargando] = useState(false);


    
    const handleCrearImagen = async(e) => {
        setCargando(true);
        const resp = await slideshowCreateImagen({ titulo:formTitulo, img: imagen })
        setCargando(false);

        if( resp ){
          setFormTitulo('');
          valorImagen(null);
          queryClient.invalidateQueries({ queryKey: ['slideshow-principal'] });
        }
    }


    return (

        <form onSubmit={ handleCrearImagen } >
            <Grid container spacing={ 2 }>
                {/* <MostrarImagen /> */}
                <AvatarScreen carpeta="usuarios" />

                <Grid item xs={12} sm={12}>
                    <TextField
                        label="Titulo"
                        fullWidth
                        placeholder="Titulo"
                        value={formTitulo}
                        onChange={e => setFormTitulo(e.target.value)}
                    />
                </Grid>
            </Grid>

            <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={7}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Crear Imagen'
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>
        </form>

    )
}